import { ILiftSettings } from '@llws/lift-entity-interfaces';
import { ActionContext } from 'vuex';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/client-api/clients/:param/lift_settings';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  orderBy: [{ field: 'moduleKey', direction: 'asc' }],
  limit: 999,
};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ILiftSettings>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'lift-settings/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,

    getByModuleKeys: async (
      ctx: ActionContext<unknown, unknown>,
      payload: {
        clientId: string | number,
        websiteId: string | number,
        moduleKeys: string[]
      },
    ) => {
      const orderBy = 'orderBy=id~asc&limit=999';
      const filters = `moduleKey~in:${payload.moduleKeys.join('|')}`;

      const requestClientId = payload.clientId;

      const list = await adminRequest.get(
        `/client-api/clients/${requestClientId}/lift_settings?where=clientId:${requestClientId},siteId:${payload.websiteId},${filters}&${orderBy}`,
      );

      ctx.commit('set', list);
    },
    getByKey: async (
      ctx: ActionContext<unknown, unknown>,
      payload: {
        clientId: string | number,
        key: string
      },
    ) => {
      const orderBy = 'orderBy=id~asc&limit=999';
      const list = await adminRequest.get(
        `/client-api/clients/${payload.clientId}/lift_settings?where=key:${payload.key}&${orderBy}`,
      );
      ctx.commit('set', list);
    },
  },
};
